import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationVcsAgentPoolCreateArgs, VcsAgentPool } from "types/generated";

import { VcsAgentPoolView } from "./types";

type GetVCSAgentPoolsData = {
  vcsAgentPools: VcsAgentPoolView[];
};

export const GET_VCS_AGENT_POOLS: TypedDocumentNode<GetVCSAgentPoolsData> = gql`
  query GetVCSAgentPools {
    vcsAgentPools {
      id
      name
      description
      config
      deleted
      agentConnections {
        id
        metadata
      }
    }
  }
`;

export type CreateVCSAgentPoolData = Pick<VcsAgentPool, "id" | "name" | "config">;

export const CREATE_VCS_AGENT_POOL: TypedDocumentNode<
  { vcsAgentPoolCreate?: CreateVCSAgentPoolData },
  MutationVcsAgentPoolCreateArgs
> = gql`
  mutation CreateVCSAgentPool($name: String!, $description: String) {
    vcsAgentPoolCreate(name: $name, description: $description) {
      id
      name
      config
    }
  }
`;
